module.exports = __webpack_public_path__ + "img/stock1.93b903a7.png";